import { EndSessionRequest } from '@azure/msal-browser'
import { useMutation } from '@tanstack/react-query'

import { activeMsalVersion } from 'setup/azureB2C'

export const useSignOutMutation = () => {
  return useMutation({ mutationFn: (params?: EndSessionRequest) => activeMsalVersion.logoutRedirect(params) })
}
